import { Component, OnInit, Input } from '@angular/core';
import { FormGroup, Validators, FormBuilder } from '@angular/forms';
import { ValidationHandler } from 'app/helpers/validation.handler';
import { GetStartedService } from 'app/website/services/get-started.service';
import { GetStarted } from 'app/website/models/get-started.model';
import { ActivatedRoute, Router } from '@angular/router';
import { ToastService } from 'ng-uikit-pro-standard';

@Component({
  selector: 'site-get-start',
  templateUrl: './get-started.component.html',
  styleUrls: ['./get-started.component.scss']
})
export class GetStartedComponent implements OnInit {
  chosenPlan: any;
  loading: boolean = false;

  constructor(private formBuilder: FormBuilder, private _validationHandler: ValidationHandler, private getStartedService: GetStartedService,
    private Route: ActivatedRoute, private router: Router, private toastrService: ToastService) { }

  ngOnInit() {
  }


  getStartForm: FormGroup = this.formBuilder.group({
    name: ['', Validators.required],
    email: ['', [Validators.required, Validators.email]],
    phone: [''],
    company: ['']
  })


  getStart(Form) {
    this.loading = true;
    if (!Form.valid) {
      this._validationHandler.onSubmitCheck(Form);
      this.loading = false;
      return;
    }
    let model: GetStarted = {
      name: Form.value.name,
      email: Form.value.email,
      phone: (Form.value.phone && Form.value.phone.length != 0) ? Form.value.phone : undefined,
      company: (Form.value.company && Form.value.company.length != 0) ? Form.value.company : undefined,
      website_url: this.router.url.toString(),
      chosen_plan: this.chosenPlan ? this.chosenPlan : undefined,
      utm_campaign: this.Route.snapshot.queryParams['utm_campaign'] ? this.Route.snapshot.queryParams['utm_campaign'] : undefined,
      utm_medium: this.Route.snapshot.queryParams['utm_medium'] ? this.Route.snapshot.queryParams['utm_medium'] : undefined,
      utm_source: this.Route.snapshot.queryParams['utm_source'] ? this.Route.snapshot.queryParams['utm_source'] : undefined
    }
    
    this.getStartedService.getStart(model).subscribe(res => {
        this.loading = false;
        this.toastrService.success('Thank you!\nWe will get back to you shortly.', 'Sent' ,{positionClass: 'md-toast-top-right'});        
      this.getStartForm.reset();
    },
    err => {
      this.toastrService.error('Couldn\'t send info', 'Error' ,{positionClass: 'md-toast-top-right'});
      this.loading = false;
    });
  }

}
